import { changeLanguage } from "i18next";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

const languages = [
  {
    code: "en",
    countryCode: "gb",
    name: "English",
  },
  {
    code: "it",
    countryCode: "it",
    name: "Italiano",
  },
];

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="border-yellow border-t-2 gap-8 grid px-4 py-12 text-sm sm:grid-cols-2 md:grid-cols-3 lg:px-24">
      <div>
        <h4 className="font-bold mb-4 uppercase md:text-lg">{t("Terms")}</h4>
        <ul className="space-y-1">
          <li>
            <a
              href="http://rigatoservice.it/wp-content/uploads/2016/08/CGV-Rigato-Service-Srl.pdf"
              rel="noreferrer"
              target="_blank"
            >
              {t("Terms and conditions")}
            </a>
          </li>
          <li>
            <NavLink to="payments">{t("Secure payments")}</NavLink>
          </li>
          <li>
            <NavLink to="shipping">{t("Shipping")}</NavLink>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="font-bold mb-4 uppercase md:text-lg">{t("Info")}</h4>
        <ul className="space-y-1">
          <li>
            <NavLink to="privacy">{t("Privacy")}</NavLink>
          </li>
          <li>
            <NavLink to="cookies">{t("Cookies")}</NavLink>
          </li>
          <li>
            <NavLink to="copyright">{t("Copyright")}</NavLink>
          </li>
        </ul>
      </div>

      <div>
        <h4 className="font-bold mb-4 uppercase md:text-lg">
          {t("Languages")}
        </h4>
        <ul className="space-y-1">
          {languages.map(({ code, countryCode, name }) => (
            <li key={code}>
              <button onClick={() => changeLanguage(code)}>
                <span className={`fi fi-${countryCode} mr-2`}></span>
                <span>{name}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Footer;
